import script from "./d3d-edit.vue?vue&type=script&lang=ts&setup=true&async=true"
export * from "./d3d-edit.vue?vue&type=script&lang=ts&setup=true&async=true"

import "./d3d-edit.vue?vue&type=style&index=0&id=01bf1f16&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01bf1f16"]])

export default __exports__